import { render, staticRenderFns } from "./News_main.vue?vue&type=template&id=70e91e15"
import script from "./News_main.vue?vue&type=script&lang=js"
export * from "./News_main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports